import { Routes } from '@angular/router';

// Carries no `import()`, so the playground chunk is never emitted. See `playground.routes.ts`.
export const PLAYGROUND_ROUTES: Routes = [];
